<div class="main mat-typography mat-body mat-app-background main">

  <div>
    <form #form="ngForm" [formGroup]="emailForm" class='email-form' (submit)="submit(emailForm)">
      <!-- Agency Name-->
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Agency Name</mat-label>
          <mat-select aria-label="Agency Name" formControlName="agency" (selectionChange)="agencyChange($event.value)">
            @for (agency of agenciesForDisplay; track agency) {
              <mat-option [value]="agency">
                {{agency.agencyName}} - {{agency.region}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Agency number-->
      <div>
        <mat-form-field appearance="outline">
          <input matInput type="textbox" formControlName="agencyNumber" maxlength='15' placeholder="Agency Number">
          @if (emailForm.controls['agencyNumber'].errors?.pattern) {
            <mat-error>Please enter only alphanumeric
            characters</mat-error>
          }
          @if (emailForm.controls['agencyNumber'].errors?.minlength) {
            <mat-error>Please enter minimum 4 characters
            </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- Npn Number-->
      <div>
        <mat-form-field appearance="outline" floatLabel="always">
          <input matInput formControlName="npnNumber" pattern="[0-9]*"
            placeholder="{{selectedMarket === linesOfBusiness.senior ? 'National Producer Number' : 'Agency Id'}}"
            maxlength='8' type="text">
            @if (emailForm.controls['npnNumber'].errors?.pattern) {
              <mat-error>NPN must be numbers only
              </mat-error>
            }
          </mat-form-field>
        </div>
        <!-- zip code -->
        <ptl-zip-code-and-county-select (zipAndCountyChanged)="zipCountyChanged($event)" [preloadedValues]="stateValues">
        </ptl-zip-code-and-county-select>
        <div class="button-and-errors">
          <div class="errors">
            <!-- ERRORS -->
            @if (regionMismatch) {
              <mat-error>
                Selected agency region does not match the zipcode
              </mat-error>
            }
          </div>
        </div>
        <!-- Email-->
        <div>
          <mat-form-field appearance="outline">
            <input matInput formControlName="emailId" placeholder="Customer Email Address">
            @if (emailForm.controls['emailId'].errors?.email) {
              <mat-error>Please enter a valid email address</mat-error>
            }
            @if (emailForm.controls['emailId'].errors?.required) {
              <mat-error>This field is required.</mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Year-->
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Year</mat-label>
            <mat-select aria-label="Year" formControlName="yearField">
              @for (year of yearOptions; track year) {
                <mat-option [value]="year">
                  {{year}}
                </mat-option>
              }
            </mat-select>
            @if (emailForm.controls['yearField'].errors?.required) {
              <mat-error>This field is required.</mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Referral type-->
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Referral Type</mat-label>
            <mat-select aria-label="Referral Type" formControlName="referralType">
              @for (referralType of referralTypes; track referralType) {
                <mat-option [value]="referralType.value">
                  {{referralType.name}}
                </mat-option>
              }
            </mat-select>
            @if (emailForm.controls['referralType'].errors?.required) {
              <mat-error>This field is required.</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="button-container">
          <!-- SUBMIT -->
          @if (!isLoading) {
            <button type="submit" mat-raised-button color="primary" mat-button [disabled]="!emailForm?.valid"
            class="primary-btn">Send Email</button>
          }

          @if (isLoading) {
            <mat-spinner [diameter]="25"></mat-spinner>
          }
        </div>

      </form>
    </div>

  </div>
